require("core-js/modules/es.array.reduce.js");

require("core-js/modules/es.array.reduce.js");
/*! For license information please see index.js.LICENSE.txt */


(function () {
  "use strict";

  var r = {
    296: function _(r, e, t) {
      var n = t(689),
          o = Symbol.for("react.element"),
          a = Symbol.for("react.fragment"),
          i = Object.prototype.hasOwnProperty,
          l = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
          c = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      };

      function u(r, e, t) {
        var n,
            a = {},
            u = null,
            s = null;

        for (n in void 0 !== t && (u = "" + t), void 0 !== e.key && (u = "" + e.key), void 0 !== e.ref && (s = e.ref), e) {
          i.call(e, n) && !c.hasOwnProperty(n) && (a[n] = e[n]);
        }

        if (r && r.defaultProps) for (n in e = r.defaultProps) {
          void 0 === a[n] && (a[n] = e[n]);
        }
        return {
          $$typeof: o,
          type: r,
          key: u,
          ref: s,
          props: a,
          _owner: l.current
        };
      }

      e.Fragment = a, e.jsx = u, e.jsxs = u;
    },
    261: function _(r, e, t) {
      r.exports = t(296);
    },
    689: function _(r) {
      r.exports = require("react");
    }
  },
      e = {};

  function t(n) {
    var o = e[n];
    if (void 0 !== o) return o.exports;
    var a = e[n] = {
      exports: {}
    };
    return r[n](a, a.exports, t), a.exports;
  }

  t.n = function (r) {
    var e = r && r.__esModule ? function () {
      return r.default;
    } : function () {
      return r;
    };
    return t.d(e, {
      a: e
    }), e;
  }, t.d = function (r, e) {
    for (var n in e) {
      t.o(e, n) && !t.o(r, n) && Object.defineProperty(r, n, {
        enumerable: !0,
        get: e[n]
      });
    }
  }, t.o = function (r, e) {
    return Object.prototype.hasOwnProperty.call(r, e);
  }, t.r = function (r) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(r, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(r, "__esModule", {
      value: !0
    });
  };
  var n = {};
  (function () {
    function r(e) {
      var t,
          n,
          o = "";
      if ("string" == typeof e || "number" == typeof e) o += e;else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) {
        e[t] && (n = r(e[t])) && (o && (o += " "), o += n);
      } else for (t in e) {
        e[t] && (o && (o += " "), o += t);
      }
      return o;
    }

    t.r(n), t.d(n, {
      CarvanaHeaderContext: function CarvanaHeaderContext() {
        return j.CarvanaHeaderContext;
      },
      CarvanaHeaderPlugin: function CarvanaHeaderPlugin() {
        return T;
      },
      CarvanaHeaderProvider: function CarvanaHeaderProvider() {
        return j.CarvanaHeaderProvider;
      },
      default: function _default() {
        return D;
      },
      getHeaderManifest: function getHeaderManifest() {
        return h;
      }
    });

    var e = function e() {
      for (var e, t, n = 0, o = ""; n < arguments.length;) {
        (e = arguments[n++]) && (t = r(e)) && (o && (o += " "), o += t);
      }

      return o;
    },
        o = {
      "logo-wrapper": "ukEasmqzGkak88VlAYki",
      "logo-separator": "u5wnbvZoS_WWCfdrYXMg",
      "desktop-logo": "DzduSzxnryQ9O8JC9wMt",
      "mobile-logo": "OxVcN3Fo9kz9517BuSFA"
    };

    var a = t(261),
        i = function i(r) {
      return "".concat("https://assets.fastly.carvana.io", "/partner-header-logos-assets/helios-").concat(r, ".svg");
    };

    function l(r) {
      var t = r.className,
          n = void 0 === t ? "" : t,
          l = r.partnerVanityUrlName,
          c = void 0 === l ? "notused" : l,
          u = r.onClick,
          s = "notused" === c ? "carvana" : c,
          f = i("desktop-".concat(s)),
          y = i("mobile-".concat(s));
      return (0, a.jsx)("div", {
        className: e(o["logo-wrapper"], n),
        children: (0, a.jsxs)("a", {
          href: "/",
          target: "_self",
          title: "Carvana",
          onClick: u,
          children: [(0, a.jsx)("div", {
            className: o["desktop-logo"],
            children: (0, a.jsx)("img", {
              src: f,
              alt: "Carvana"
            })
          }), (0, a.jsx)("div", {
            className: o["mobile-logo"],
            children: (0, a.jsx)("img", {
              src: y,
              alt: "Carvana"
            })
          })]
        })
      });
    }

    var c = {
      "header-wrapper": "_9flirVCTysoofC5vp5Qg",
      "nav-bar": "jymWWXeZp1wEuxcZ3bpi",
      account: "Apq_yfMQ7lVg40yQyTrD",
      break: "vsG6R9Ew8B6I8suLxnPA"
    };
    var u = t(689);

    function s(r, e) {
      (null == e || e > r.length) && (e = r.length);

      for (var t = 0, n = new Array(e); t < e; t++) {
        n[t] = r[t];
      }

      return n;
    }

    var f = function f(r) {
      var t,
          n,
          o = r.href,
          i = r.children,
          l = r.onClick,
          c = (t = (0, u.useState)(!1), n = 2, function (r) {
        if (Array.isArray(r)) return r;
      }(t) || function (r, e) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

        if (null != t) {
          var n,
              o,
              a,
              i,
              l = [],
              c = !0,
              u = !1;

          try {
            if (a = (t = t.call(r)).next, 0 === e) {
              if (Object(t) !== t) return;
              c = !1;
            } else for (; !(c = (n = a.call(t)).done) && (l.push(n.value), l.length !== e); c = !0) {
              ;
            }
          } catch (r) {
            u = !0, o = r;
          } finally {
            try {
              if (!c && null != t.return && (i = t.return(), Object(i) !== i)) return;
            } finally {
              if (u) throw o;
            }
          }

          return l;
        }
      }(t, n) || function (r, e) {
        if (r) {
          if ("string" == typeof r) return s(r, e);
          var t = Object.prototype.toString.call(r).slice(8, -1);
          return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? s(r, e) : void 0;
        }
      }(t, n) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }()),
          f = c[0],
          y = c[1];
      return (0, u.useEffect)(function () {
        var r;
        (null === (r = window) || void 0 === r ? void 0 : r.location.pathname) === o && y(!0);
      }, []), (0, a.jsx)(a.Fragment, {
        children: (0, a.jsx)("a", {
          href: o,
          className: e("o_3CXzu5ryIXwGUee3r9", f ? "E3JTBh0baGQctJbBGZ5E" : ""),
          onClick: l,
          children: i
        })
      });
    };

    var y;

    function d() {
      return d = Object.assign ? Object.assign.bind() : function (r) {
        for (var e = 1; e < arguments.length; e++) {
          var t = arguments[e];

          for (var n in t) {
            Object.prototype.hasOwnProperty.call(t, n) && (r[n] = t[n]);
          }
        }

        return r;
      }, d.apply(this, arguments);
    }

    var p = function p(r) {
      return u.createElement("svg", d({
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 16,
        fill: "none"
      }, r), y || (y = u.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.705 2.667a4.667 4.667 0 1 0 3.237 8.027.683.683 0 0 1 .124-.123 4.667 4.667 0 0 0-3.361-7.904Zm4.688 8.411a6 6 0 1 0-.943.943l2.45 2.45a.667.667 0 1 0 .943-.943l-2.45-2.45Z",
        clipRule: "evenodd"
      })));
    };

    function v(r) {
      var e = r.className,
          t = void 0 === e ? "" : e;
      return (0, a.jsxs)("div", {
        className: t,
        children: [(0, a.jsxs)(f, {
          href: "/cars",
          children: [(0, a.jsx)(p, {}), (0, a.jsx)("span", {
            children: "Search"
          })]
        }), (0, a.jsx)(f, {
          href: "/sell-my-car",
          children: "Sell or Trade"
        }), (0, a.jsx)(f, {
          href: "/financing",
          children: "Finance"
        })]
      });
    }

    function b(r) {
      var e = r.cookies,
          t = (null == e ? void 0 : e.PartnerVanityUrlName) || "notused";
      return (0, a.jsx)("nav", {
        "aria-label": "site-navigation",
        children: (0, a.jsxs)("div", {
          className: c["header-wrapper"],
          "aria-label": "site-navigation",
          children: [(0, a.jsx)(l, {
            partnerVanityUrlName: t
          }), (0, a.jsx)("div", {
            className: c.account
          }), (0, a.jsx)("div", {
            className: c.break
          }), (0, a.jsx)(v, {
            className: c["nav-bar"]
          })]
        })
      });
    }

    function m(r, e) {
      (null == e || e > r.length) && (e = r.length);

      for (var t = 0, n = new Array(e); t < e; t++) {
        n[t] = r[t];
      }

      return n;
    }

    var g = function g() {
      return document.cookie.split("; ").reduce(function (r, e) {
        var t,
            n = function (r) {
          if (Array.isArray(r)) return r;
        }(t = e.split("=")) || function (r) {
          if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
        }(t) || function (r, e) {
          if (r) {
            if ("string" == typeof r) return m(r, e);
            var t = Object.prototype.toString.call(r).slice(8, -1);
            return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? m(r, e) : void 0;
          }
        }(t) || function () {
          throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }(),
            o = n[0],
            a = n.slice(1);

        return r[o] = a.join("="), r;
      }, {});
    },
        h = function h() {
      var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "development";
      if ("undefined" == typeof window || !r) return null;
      var e,
          t,
          n,
          o,
          a,
          i,
          l,
          c = ("core-header-redesign", 2 === (n = "; ".concat(document.cookie).split("; ".concat("core-header-redesign", "="))).length && null !== (e = null === (t = n.pop()) || void 0 === t ? void 0 : t.split(";").shift()) && void 0 !== e ? e : null),
          u = {
        dev: "fastly.zagforward.com",
        development: "fastly.zagforward.com",
        test: "fastly.carvanatech.com",
        prod: "fastly.carvana.io",
        production: "fastly.carvana.io"
      }[r],
          s = (i = new Date(), l = 15 * Math.round(i.getMinutes() / 15), "".concat(i.getDate()).concat(i.getHours()).concat(l));
      return "treatment" === c ? (o = "static", a = "/header-module/header/assets-manifest.json") : (o = "assets", a = "/header/module/assets-manifest.json"), "https://".concat(o, ".").concat(u).concat(a, "?v=").concat(s);
    };

    var j = require("@carvana/header2.0");

    var O = t.n(j);
    var w = {
      "core-header-ui": "E9Bg8PdufZVnZnm5zjPR"
    };

    function S(r) {
      return S = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (r) {
        return typeof r;
      } : function (r) {
        return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, S(r);
    }

    function x(r, e) {
      var t = Object.keys(r);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(r);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(r, e).enumerable;
        })), t.push.apply(t, n);
      }

      return t;
    }

    function P(r) {
      for (var e = 1; e < arguments.length; e++) {
        var t = null != arguments[e] ? arguments[e] : {};
        e % 2 ? x(Object(t), !0).forEach(function (e) {
          A(r, e, t[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : x(Object(t)).forEach(function (e) {
          Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(t, e));
        });
      }

      return r;
    }

    function A(r, e, t) {
      return (e = function (r) {
        var e = function (r, e) {
          if ("object" !== S(r) || null === r) return r;
          var t = r[Symbol.toPrimitive];

          if (void 0 !== t) {
            var n = t.call(r, "string");
            if ("object" !== S(n)) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return String(r);
        }(r);

        return "symbol" === S(e) ? e : String(e);
      }(e)) in r ? Object.defineProperty(r, e, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : r[e] = t, r;
    }

    function k(r, e) {
      (null == e || e > r.length) && (e = r.length);

      for (var t = 0, n = new Array(e); t < e; t++) {
        n[t] = r[t];
      }

      return n;
    }

    var E = function E(r) {
      return void 0 === r ? {} : "string" == typeof r ? r.split("; ").reduce(function (r, e) {
        var t,
            n,
            o = (t = e.split("="), n = 2, function (r) {
          if (Array.isArray(r)) return r;
        }(t) || function (r, e) {
          var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

          if (null != t) {
            var n,
                o,
                a,
                i,
                l = [],
                c = !0,
                u = !1;

            try {
              if (a = (t = t.call(r)).next, 0 === e) {
                if (Object(t) !== t) return;
                c = !1;
              } else for (; !(c = (n = a.call(t)).done) && (l.push(n.value), l.length !== e); c = !0) {
                ;
              }
            } catch (r) {
              u = !0, o = r;
            } finally {
              try {
                if (!c && null != t.return && (i = t.return(), Object(i) !== i)) return;
              } finally {
                if (u) throw o;
              }
            }

            return l;
          }
        }(t, n) || function (r, e) {
          if (r) {
            if ("string" == typeof r) return k(r, e);
            var t = Object.prototype.toString.call(r).slice(8, -1);
            return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? k(r, e) : void 0;
          }
        }(t, n) || function () {
          throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }()),
            a = o[0],
            i = o[1];
        return P(P({}, r), {}, A({}, a, i));
      }, {}) : function (r) {
        return Array.isArray(r) && r.every(function (r) {
          return "string" == typeof r.name && "string" == typeof r.value;
        });
      }(r) ? r.reduce(function (r, e) {
        return P(P({}, r), {}, A({}, e.name, e.value));
      }, {}) : r;
    };

    function C(r) {
      return C = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (r) {
        return typeof r;
      } : function (r) {
        return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, C(r);
    }

    var _ = ["cookies"];

    function N(r, e) {
      var t = Object.keys(r);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(r);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(r, e).enumerable;
        })), t.push.apply(t, n);
      }

      return t;
    }

    function I(r, e) {
      (null == e || e > r.length) && (e = r.length);

      for (var t = 0, n = new Array(e); t < e; t++) {
        n[t] = r[t];
      }

      return n;
    }

    function T(r) {
      var e,
          t,
          n = r.cookies,
          o = function (r, e) {
        if (null == r) return {};

        var t,
            n,
            o = function (r, e) {
          if (null == r) return {};
          var t,
              n,
              o = {},
              a = Object.keys(r);

          for (n = 0; n < a.length; n++) {
            t = a[n], e.indexOf(t) >= 0 || (o[t] = r[t]);
          }

          return o;
        }(r, e);

        if (Object.getOwnPropertySymbols) {
          var a = Object.getOwnPropertySymbols(r);

          for (n = 0; n < a.length; n++) {
            t = a[n], e.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(r, t) && (o[t] = r[t]);
          }
        }

        return o;
      }(r, _),
          i = E(n),
          l = (e = (0, u.useState)(i), t = 2, function (r) {
        if (Array.isArray(r)) return r;
      }(e) || function (r, e) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

        if (null != t) {
          var n,
              o,
              a,
              i,
              l = [],
              c = !0,
              u = !1;

          try {
            if (a = (t = t.call(r)).next, 0 === e) {
              if (Object(t) !== t) return;
              c = !1;
            } else for (; !(c = (n = a.call(t)).done) && (l.push(n.value), l.length !== e); c = !0) {
              ;
            }
          } catch (r) {
            u = !0, o = r;
          } finally {
            try {
              if (!c && null != t.return && (i = t.return(), Object(i) !== i)) return;
            } finally {
              if (u) throw o;
            }
          }

          return l;
        }
      }(e, t) || function (r, e) {
        if (r) {
          if ("string" == typeof r) return I(r, e);
          var t = Object.prototype.toString.call(r).slice(8, -1);
          return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? I(r, e) : void 0;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }()),
          c = l[0],
          s = l[1];

      if ((0, u.useEffect)(function () {
        if ("undefined" != typeof window && void 0 === n) {
          var r = g(),
              e = E(r);
          s(e);
        }
      }, []), "control" === ((null == c ? void 0 : c["core-header-redesign"]) || "control")) return (0, a.jsx)(O(), function (r) {
        for (var e = 1; e < arguments.length; e++) {
          var t = null != arguments[e] ? arguments[e] : {};
          e % 2 ? N(Object(t), !0).forEach(function (e) {
            var n, o, a;
            n = r, o = e, a = t[e], (o = function (r) {
              var e = function (r, e) {
                if ("object" !== C(r) || null === r) return r;
                var t = r[Symbol.toPrimitive];

                if (void 0 !== t) {
                  var n = t.call(r, "string");
                  if ("object" !== C(n)) return n;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }

                return String(r);
              }(r);

              return "symbol" === C(e) ? e : String(e);
            }(o)) in n ? Object.defineProperty(n, o, {
              value: a,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : n[o] = a;
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : N(Object(t)).forEach(function (e) {
            Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(t, e));
          });
        }

        return r;
      }({}, o));
      var f = "core-header-ui";
      return (0, a.jsx)("div", {
        id: f,
        className: w[f],
        "data-testid": f,
        children: (0, a.jsx)(b, {
          cookies: c
        })
      });
    }

    var D = T;
  })(), module.exports = n;
})();